import catchContent from "./catchContent.vue"
export default catchContent



// WEBPACK FOOTER //
// ./src/layout/catchContent/index.js